export default __webpack_public_path__ + "static/media/food-menu4.d35647c3.jfif";